let load = require('./helpers/browser/esm-js-loader-shards-super.js')(4);
module.exports = (load("c1tK3")).then(() => parcelRequire('lOtqx'));